//
//
//
//
//
//
//
//
//
//
//
//
//

import faq from "@/apps/data-platform/modules/help_center/FAQPage.vue";
import videos from "@/apps/data-platform/modules/help_center/VideosPage.vue";
import sugerences from "@/apps/data-platform/modules/help_center/SugerenciasPage.vue";
import news from "@/apps/data-platform/modules/help_center/NewsPage.vue";
export default {
  props: {
    element: {
      type: String,
      default: ''
    }
  },
  components: {
    faq: faq,
    videos: videos,
    sugerences: sugerences,
    news: news
  },
  data: function data() {
    return {
      flagVideo: true,
      actualVideo: [],
      element_path: null,
      module_path: null
    };
  },
  created: function created() {
    console.log(this.$route.params);
    this.element_path = this.$route.params.element_path;
    this.module_path = +this.$route.params.module_path;
  },
  computed: {
    items: function items() {
      return [this.traductor('help_center.news'), this.traductor('help_center.read'), this.traductor('help_center.videos'), this.traductor('help_center.sugerences')];
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSubmit: function onSubmit() {
      this.$refs['sugerences'].onSubmit();
    }
  }
};